module.exports = __webpack_public_path__ + "static/media/salisbury-23.174b28a5.jpg";